



















































import { Component, Prop,Vue } from "vue-property-decorator";
import {
  Configuration,
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic
} from "@/configuration";
 

@Component({
    data() {
      return {
      }
    }
})
    export default class Puntos extends Vue {}
